import React, { useEffect } from 'react';

const HomeHowToMeasure: React.FC = () => {
    useEffect(() => {
        const script = document.createElement('script');
        script.src = "https://www.instagram.com/embed.js";
        script.async = true;
        script.defer = true;
        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, []);


    return (
        <div>
            {/* <section className="bg-light">
                <h2 className="sec-title text-center">Connect with us Globally</h2>
                <div className="col-lg-12 col-md-12 ">

                    <div className="card bg-light border-light">


                        <div className="row p-4">

                            <div className="col-xl-6 col-md-6 text-center p-2">
                                <h4>How To Measure?</h4>
                                <div className="rounded overflow-hidden shadow-lg p-2 bg-light">

                                    <div style={{ position: "relative", width: "100%", paddingTop: "56.25%" }}>
                                        <iframe
                                            src="https://www.youtube.com/embed/XqcM8nwCm7o?controls=1"
                                            title="YouTube video player"
                                            className="rounded"
                                            style={{
                                                position: "absolute",
                                                top: 0,
                                                left: 0,
                                                width: "100%",
                                                height: "100%",
                                                border: "none",
                                            }}
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                        ></iframe>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-6 col-md-6 text-center p-2">
                                <h4>How Venetz Works?</h4>
                                <div className="rounded overflow-hidden shadow-lg p-2 bg-light">

                                    <div style={{ position: "relative", width: "100%", paddingTop: "56.25%" }}>
                                        <iframe
                                            src="https://www.youtube.com/embed/sJUpXic5_rA?si=I3rMKfRfbfz685fM"
                                            title="YouTube video player"
                                            className="rounded"
                                            style={{
                                                position: "absolute",
                                                top: 0,
                                                left: 0,
                                                width: "100%",
                                                height: "100%",
                                                border: "none",
                                            }}
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                        ></iframe>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}
            <section className="bg-light py-5">
                <h2 className="sec-title text-center mb-4">See Our Social Feeds</h2>
                <div className="container-fluid">
                    <div className=" p-4">
                        <div className="row g-5 justify-content-center">
                            {/* Video 1 */}
                            <div className="col-xl-5 col-md-5 text-center">
                                <h4>How To Measure?</h4>
                                <div className="rounded overflow-hidden shadow-lg p-2 bg-light">
                                    <div style={{ position: "relative", width: "100%", paddingTop: "56.25%" }}>
                                        <iframe
                                            src="https://www.youtube.com/embed/XqcM8nwCm7o?controls=1"
                                            title="How To Measure?"
                                            className="rounded"
                                            style={{
                                                position: "absolute",
                                                top: 0,
                                                left: 0,
                                                width: "100%",
                                                height: "100%",
                                                border: "none",
                                            }}
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                        ></iframe>
                                    </div>
                                </div>
                            </div>
                            {/* Video 2 */}
                            <div className="col-xl-5 col-md-5 text-center">
                                <h4>How Venetz Works?</h4>
                                <div className="rounded overflow-hidden shadow-lg p-2 bg-light">
                                    <div style={{ position: "relative", width: "100%", paddingTop: "56.25%" }}>
                                        <iframe
                                            src="https://www.youtube.com/embed/sJUpXic5_rA?si=I3rMKfRfbfz685fM"
                                            title="How Venetz Works?"
                                            className="rounded"
                                            style={{
                                                position: "absolute",
                                                top: 0,
                                                left: 0,
                                                width: "100%",
                                                height: "100%",
                                                border: "none",
                                            }}
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                        ></iframe>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* </section> */}
                {/* <section className="mb-3"> */}
                <div className="container-fluid">
                    <div className="d-flex justify-content-center">

                        <div className="col-lg-12 col-md-12">
                            <div className="row g-4 justify-content-center">
                                <div className="card p-2 m-2 mx-4 shadow-lg text-center">
                                    <div className="rounded overflow-hidden">
                                        <blockquote className="rounded instagram-media w-100" data-instgrm-permalink="https://www.instagram.com/reel/DGzt4DMt3An/" data-instgrm-version="14"></blockquote>
                                    </div>
                                </div>
                                <div className="card p-2 m-2 mx-4 shadow-lg text-center">
                                    <div className="rounded overflow-hidden">
                                        <blockquote className="rounded instagram-media w-100" data-instgrm-permalink="https://www.instagram.com/reel/DIwDRRVNLXi/" data-instgrm-version="14"></blockquote>
                                    </div>
                                </div>
                                <div className="card p-2 m-2 mx-4 shadow-lg text-center">
                                    <div className="rounded overflow-hidden ">
                                        <blockquote className="rounded instagram-media w-100" data-instgrm-permalink="https://www.instagram.com/reel/DI3xqdGPKTQ/" data-instgrm-version="14"></blockquote>
                                    </div>
                                </div>
                                <div className="card p-2 m-2 mx-4 shadow-lg text-center">
                                    <div className="rounded overflow-hidden ">
                                        <blockquote className="rounded instagram-media w-100" data-instgrm-permalink="https://www.instagram.com/reel/DGzt4DMt3An/" data-instgrm-version="14"></blockquote>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
};
export default HomeHowToMeasure;